import { AccessibilityPageContent } from '@/components/Accessibility/AccessibilityPageContent';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import type { Config } from '@/pageConfig/accessibility';
import { Box } from '@lemonade-hq/cdk';
import { DocumentTypes } from 'contentlayer/generated';
import type React from 'react';
import style from 'styled-components';

const ContentWrapper = style(Box)`
  position: relative;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
`;

interface AccessibilityPageTemplateProps {
  config: Config;
}

export const AccessibilityPageTemplate: React.FC<AccessibilityPageTemplateProps> = ({ config }) => {
  useShowHeaderCtaOnScroll(true);
  return (
    <Layout pt={[70, 60, 120]} headerActions={config.layout.headerActions}>
      <SEO {...config.seo} />
      <ContentWrapper px="20px" pb="40px">
        <AccessibilityPageContent content={config.MDXContent as DocumentTypes} />
      </ContentWrapper>
    </Layout>
  );
};
